import React, { useEffect, useState } from "react";
import Viewmore from "../SiteComponants/Viewmore";
import NoItemFound from "../SiteComponants/NoItemFound";
import SectionHeader from "../SectionHeader/SectionHeader";
import ItemCard from "../ItemCard/ItemCard";

const ItemSection = ({ heading, showCount, showAll, prods, badge }) => {
  const [showProducts, setShowProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (showAll) {
      setShowProducts(prods);
    } else {
      const shoprod = prods.slice(0, showCount);
      setShowProducts(shoprod);
    }

    setIsLoading(false);
  }, [prods]);
  // const filterProducts = (tagName, index) => {
  //   let newProducts = prods?.filter(
  //     (prd) => prd[index] === tagName || (tagName === "" && index === "")
  //   );

  //   setShowProducts(newProducts);
  // };
  return (
    <div className="my-6">
      <div className="w-full md:container mx-auto  p-2">
        <SectionHeader heading={heading} />
        <div
          className={`grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5  gap-4 md:gap-6   auto-rows-auto`}
        >
          {showProducts?.length > 0 ? (
            showProducts.map((prd, i) => (
              <ItemCard badge={badge} key={i} prod={prd} />
            ))
          ) : (
            <NoItemFound msg={`No ${heading} Available Now`} />
          )}
        </div>
      </div>
      {heading === "Sales" && prods.length > 0 ? (
        <Viewmore link={"/products"} />
      ) : (
        ""
      )}
    </div>
  );
};

export default ItemSection;
